import { Text, VStack } from "@chakra-ui/layout";
import type { Brand, Project } from "@src/__generated__/urql-graphql";
import { BrandLogo, ModuleTitle } from "@src/components/ui-kit";
import { WrapComponent } from "@src/utils/components/WrapComponent";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import type { DeepPick } from "ts-essentials";

interface ProjectTitleProps {
  project: Pick<Project, "title" | "code" | "numeric_code">;
  showBrandName?: boolean;
  brand: {
    name?: Brand["name"];
    image?: DeepPick<
      Brand["image"],
      {
        urls: {
          thumbnail: never;
        };
      }
    >;
  };
  className?: string;
}

export const getProjectTitle = (
  project: Pick<Project, "title" | "code" | "numeric_code">,
  enableAdditionalBrandNumericCode?: boolean,
) => {
  return `${project.title} (${project.code})${enableAdditionalBrandNumericCode && project.numeric_code ? ` (${project.numeric_code})` : ""}`;
};

const ProjectTitle = ({
  project,
  brand,
  className,
  showBrandName = false,
}: ProjectTitleProps) => {
  const { workspaceStore } = useStore();

  return (
    <div className={`flex flex-wrap items-center truncate my-1 ${className}`}>
      <div className="flex items-center truncate">
        <BrandLogo src={brand.image?.urls?.thumbnail} mr="4" />
        <WrapComponent
          if={showBrandName}
          with={(children) => (
            <VStack align="start" spacing="0">
              {children}
              <Text>{brand.name}</Text>
            </VStack>
          )}
        >
          <ModuleTitle
            text={getProjectTitle(
              project,
              workspaceStore.settings?.enableAdditionalBrandNumericCode,
            )}
          />
        </WrapComponent>
      </div>
    </div>
  );
};

export default observer(ProjectTitle);
